import { WALL_LAYOUT_KEY } from '../../utilities/constants/Constants';

export class WallLayout {
  constructor(wallLayoutData) {
    this.id = wallLayoutData.id;
    this.width = wallLayoutData.width;
    this.height = wallLayoutData.height;
    this.imagePath = wallLayoutData.image_path;
    this.layoutType = wallLayoutData.layout_type;
    this.type = WALL_LAYOUT_KEY;
    this.name = wallLayoutData.name;
  }
}
